// extracted by mini-css-extract-plugin
module.exports = {"container":"DoubleOptInRedirect_container__dIbpQ"};